import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { checkIdtfServiceProviderFeatureEnabled } from '../../../configs';
import { getLatestConnectionStatus } from '../../../legacy/pages/PatientFile/util';

const BreadcrumbNav = ({ history, me, connectionInfo }) => {
  const {
    location: { pathname },
  } = history;
  const pathParts = pathname.split('/');
  const parentPage = pathParts[1];
  const backLink = pathParts.slice(0, 2).join('/');
  const selectedSettingsTab = useSelector(
    state => state.settings && state.settings.selectedPageTab,
  );
  const selectedPatientTab = useSelector(
    state => state.patientFile && state.patientFile.selectedTab,
  );
  const dataMap = {
    patients: selectedPatientTab,
    settings: selectedSettingsTab,
  };
  const styles = {
    text: {
      textTransform: 'capitalize',
    },
    margin: {
      marginTop: '10px',
    },
  };
  const isIdtfServiceEnabled = checkIdtfServiceProviderFeatureEnabled(me);

  const getOverviewTablLabel = () => {
    const connectionStatus =
      connectionInfo &&
      connectionInfo.status &&
      getLatestConnectionStatus(connectionInfo).status;
    if (isIdtfServiceEnabled) return 'Profile';
    return connectionStatus === 'pending' || connectionStatus === 'connected'
      ? 'Overview'
      : 'Order';
  };
  const tabLabelMap = {
    EKGS: 'ECG',
    OVERVIEW: getOverviewTablLabel(),
    PROFILE: 'Profile',
    REPORTS: 'Reports',
    BLOOD_PRESSURES: 'Blood Pressure',
    WEIGHTS: 'Weight',
    TEAM_MEMBERS: 'Team Members',
    INVITE_TEAM_MEMBER: 'Invite Member',
    INBOX_SETTINGS: 'Inbox Settings',
    UPDATE_PASSWORD: 'Update Password',
    KARDIA_RX: 'KardiaRx ECG',
  };
  const handleNavigation = e => {
    e.preventDefault();
    history.push(backLink);
  };
  return (
    <Breadcrumbs aria-label="breadcrumb" style={styles.margin}>
      <Link
        color="inherit"
        href={backLink}
        underline="always"
        onClick={handleNavigation}
      >
        <Typography variant="body2" style={styles.text}>
          {parentPage}
        </Typography>
      </Link>
      <Typography variant="body2" style={styles.text}>
        {tabLabelMap[dataMap[parentPage && parentPage.toLowerCase()]]}
      </Typography>
    </Breadcrumbs>
  );
};

export default withRouter(BreadcrumbNav);



// WEBPACK FOOTER //
// ./src/views/components/BreadcrumbNavigation/BreadcrumbNav.jsx